const UnsupportedPreview = () => (
  <p className='paragraph-general mb-0 p-3'>Preview is not available for this file type.</p>
);

export default UnsupportedPreview;
